exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footIntroContainer_3IJL7I3S {\n    overflow: hidden;\n    width: 1000px;\n    margin: 0 auto;\n    margin-top: 36px;\n}\n\n.footIntroContainer_3IJL7I3S img {\n    width: 160px;\n    float: left;\n    margin-right: 50px;\n}\n\n.footIntroContainer_3IJL7I3S .txt_1D4rVlC7 {\n    margin-top: 24px;\n}\n\n.footIntroContainer_3IJL7I3S h4 {\n    font-size: 18px;\n    font-weight: bold;\n    color: #000;\n    margin-bottom: 6px;\n}\n\n.footIntroContainer_3IJL7I3S p {\n    font-size: 14px;\n    color: #666;\n    line-height: 30px;\n}\n\n.footIntroContainer_3IJL7I3S .pTs_3X_0qs6f {\n    text-align: right;\n    font-size: 14px;\n    color: #666;\n    line-height: 30px;\n}\n", ""]);

// exports
exports.locals = {
	"footIntroContainer": "footIntroContainer_3IJL7I3S",
	"txt": "txt_1D4rVlC7",
	"pTs": "pTs_3X_0qs6f"
};